import React from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'

interface IProps {
  title: string
  questions: {
    title: string
    answer: string
  }[]
}

const CONTENT = {
  title: "Frequently Asked Questions",
  description: "Curious about how it works? Learn more about our educator-approved methods, kid-safe environment, and how we tailor reading and writing challenges to your child's level."
}

const Content = styled.div`
max-width: 960px;
margin: 40px auto;
position: relative;
padding-top: 60px;


color: #351451;

  .title {
    position: relative;
    width: fit-content;
    margin: 0 auto;
    padding-top: 10px;

    img {
      position: absolute;
      top: 50px;
      right: 0;
      transform: translate(100%, -100%);
    }
}

.faq-header {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1em;
  text-align: center;
  max-width: 660px;
  margin:  0 auto;
  margin-bottom: 40px;
  h2,p {
    margin: 0;
  }
  h2 {
    font-size: 1.7em;
    font-weight: bold;
  }
  p {
    font-size: 0.9em;
  }
}

.faq-content {
  background: #fff;
  border-radius: 0.6em;
  box-shadow: 0 0 6px rgba(0,0,0,0.2);
}

.questions {
  display: flex;
  flex-direction: column;

  > *:not(:last-child) {
    border-bottom: 2px solid #9e8eac;
  }
}
.question {

  .question-button {
    height: 40px;
    width: 40px;
  }

  summary {
    padding: 1.2em;
    font-size: 1.2em;
    font-weight: bold;
    cursor: pointer;
    list-style: none;
    display: flex;
    gap: 1em;
    align-items: center;
    &::-webkit-details-marker { display: none; }
  }

  .question-title {
    flex: 1;
  }

  .question-arrow {
    width: 12px;
    height: 12px;
    border-right: 3px solid #351451;
    border-bottom: 3px solid #351451;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
    flex-shrink: 0;
  }

  &[open] .question-arrow {
    transform: rotate(-135deg);
  }

  .question--answer {
    padding: 1.2em 1.6em;
    margin-top: -1.6em;
    font-size: 1em;
    line-height: 1.5;
  }
}

`

const Wrapper = styled.div`
position: relative;
.images {

}
img {
  position: absolute;
  /* z-index: -1; */

  &.florence {
    top: 50px;
    left: 0;
    height: 300px;
    transform: translate(-100px, -90px);
  }
  &.cliff {
    right: 0;
    bottom: 0;
    height: 1000px;
    top: 500px;
  }
}

.mobile-cliff {
  position: relative;
  height: 30vh;
  width: 100%;
  img {
    position: absolute;
    right: 0;
    max-height: 50vh;
  }
  padding-bottom: 400px;
}

@media screen and (max-width: 820px) {
  /* padding-top: 20vh; */
  padding-top: 0px;

  .florence {
    display: none;
  }
  .mobile-cliff {
    display: block !important;
  }

  .title {
    max-width: 240px;
  }
}
`

export const ParentsV2_FAQSection = (props: IProps) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: props.questions.map(q => ({
      "@type": "Question",
      name: q.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.answer,
      },
    })),
  }

  return (
    <Wrapper>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className='images'>
        <img className='florence' src='/images/parents-v2/Florence landing.png' />
        <img className='cliff desktop' src='/images/parents-v2/Will-Raya-cliff-desktop.png' />
      </div>

      <Content>
        <div className='faq-header'>

          <div className='title'>
            <h2>{CONTENT.title}</h2>
            <img src='/images/parents-v2/yellow-question-doodle-icon.svg' />
          </div>

          <p>{CONTENT.description}</p>

        </div>

        <div className='faq-content'>
          <div className='questions'>
            {props.questions.map((q, i) => <details className='question' key={i}>
              <summary>
                <div className='question-button'>
                  <img src='/images/parents-v2/purple-faq-icon.svg' />
                </div>
                <div className='question-title'>{q.title}</div>
                <div className='question-arrow' />
              </summary>
              <div className='question--answer'>{q.answer}</div>
            </details>)}
          </div>
        </div>
      </Content>

      <div className='mobile-cliff mobile'>
        <img src='/images/parents-v2/Will-Raya-cliff-mobile.png' />
      </div>

    </Wrapper>
  )
}
